import React from "react";
import { STATE_KEYS } from "utils/constants/state";
import get from "lodash/get";
import { useFormikContext } from "formik";
import {
  AUTHORIZE_PAYMENT_COPY,
  CAPTURE_METHOD
} from "utils/constants/payment";
import Toggle from "react-toggle";
import { getToggleProps } from "utils/form";
import ZoneLink from "components/ZoneLink";
import { useShortLinkCaptureMethod } from "utils/hooks/shortLink";
import InheritenceDisplay from "components/InheritenceDisplay";
import StatusIcon from "components/StatusIcon";
import { STATUS } from "utils/constants/ui";
import { omitDeep } from "utils/data";
import { DOCS_ZONE_LINK } from "constants/docs";
import classnames from "classnames";

const DEFAULT_TITLE = "Authorize payment only";

const Capture = ({ name, inherited, title } = { title: DEFAULT_TITLE }) => {
  const ctxTitle = title || DEFAULT_TITLE;
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched,
    setValues
  } = useFormikContext();

  const {
    notice,
    error,
    isManualCapture,
    inheritedIsManualCapture,
    activeInheritence,
    disableManualCapture
  } = useShortLinkCaptureMethod({ inherited });

  if (activeInheritence) {
    return (
      <InheritenceDisplay
        title={ctxTitle}
        error={error}
        onRemove={() => {
          setFieldValue(
            STATE_KEYS.SHORT_LINK.PAYMENT_INTENT_DATA_CAPTURE_METHOD,
            CAPTURE_METHOD.AUTOMATIC
          );
        }}
      >
        <div className="flex flex-row justify-between items-center">
          <div className="f6 word-break pr1">
            {inheritedIsManualCapture ? "Enabled" : "Disabled"}
          </div>
          {inheritedIsManualCapture && (
            <StatusIcon status={STATUS.SUCCESS} size={20} />
          )}
        </div>
      </InheritenceDisplay>
    );
  } else {
    return (
      <div className="flex flex-column w-100">
        <div className="flex flex-row items-center justify-between">
          <label
            className={classnames("f5 fw6 db", {
              "color-error": error
            })}
          >
            {ctxTitle}
          </label>
          <Toggle
            {...getToggleProps({
              active: isManualCapture,
              disabled: disableManualCapture,
              setFieldValue: (_, active) => {
                if (
                  !get(
                    touched,
                    STATE_KEYS.SHORT_LINK.PAYMENT_INTENT_DATA_CAPTURE_METHOD
                  )
                ) {
                  setFieldTouched(
                    STATE_KEYS.SHORT_LINK.PAYMENT_INTENT_DATA_CAPTURE_METHOD,
                    true
                  );
                }

                setTimeout(() => {
                  if (active) {
                    setFieldValue(
                      STATE_KEYS.SHORT_LINK.PAYMENT_INTENT_DATA_CAPTURE_METHOD,
                      CAPTURE_METHOD.MANUAL
                    );
                  } else {
                    setValues(
                      omitDeep(
                        values,
                        STATE_KEYS.SHORT_LINK.PAYMENT_INTENT_DATA_CAPTURE_METHOD
                      )
                    );
                  }
                }, 0);
              }
            })}
          />
        </div>
        <div className="f6 pt2 lh-copy">{notice}</div>
        <div className="flex flex-column pt2">
          <div className="f6 lh-copy word-break">
            {AUTHORIZE_PAYMENT_COPY.FOOTER}
          </div>
          <div className="pt2">
            <ZoneLink
              href={DOCS_ZONE_LINK.LEARN_PAYMENT_LINKS_OVERVIEW}
              zone
              linkProps={{
                className: "link",
                target: "_blank"
              }}
            >
              <div className="f6 fw6 link__decoration--hover color-primary pointer">
                Learn more
              </div>
            </ZoneLink>
          </div>
        </div>
      </div>
    );
  }
};

export default Capture;
